module.exports = __webpack_public_path__ + "static/media/Check24.3b9cefd3.ico";